import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

export default function ContactSection() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;

    setStatus('sending');
    try {
      await addDoc(collection(db, 'inquiries'), {
        ...form,
        createdAt: serverTimestamp(),
      });
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="pf-section pf-contact">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">CONTACT</p>
        <h2 className="pf-section__title">お問い合わせ</h2>
        <p className="pf-section__lead">ご依頼・教室・取材等のお問い合わせはこちらから。</p>
      </div>

      <form className="pf-contact__form" onSubmit={onSubmit}>
        <label className="pf-contact__field">
          <span>お名前</span>
          <input name="name" value={form.name} onChange={onChange} required />
        </label>

        <label className="pf-contact__field">
          <span>メールアドレス</span>
          <input type="email" name="email" value={form.email} onChange={onChange} required />
        </label>

        <label className="pf-contact__field">
          <span>お問い合わせ内容</span>
          <textarea name="message" rows={5} value={form.message} onChange={onChange} required />
        </label>

        <button className="pf-contact__submit" type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? '送信中...' : '送信する'}
        </button>

        {status === 'sent' && <p className="pf-contact__status pf-contact__status--ok">送信しました。ありがとうございます。</p>}
        {status === 'error' && <p className="pf-contact__status pf-contact__status--err">送信に失敗しました。時間をおいて再度お試しください。</p>}
      </form>
    </section>
  );
}
